import { zergApi } from "@/service/zerg";

const prefix = "/rrhh/trabajo-adicional";

class TrabajoAdicionalService {
    async index(params) {
        try {
            const data = await zergApi.post(`${prefix}/index`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async store(params) {
        try {
            const data = await zergApi.post(`${prefix}/store`, params, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async update(params) {
        try {
            const data = await zergApi.post(`${prefix}/update`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getTrabajoAdicionalPorEmpleado(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-trabajo-adicional-por-empleado`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async actualizarEstadoTrabajoAdicional(params) {
        try {
            const data = await zergApi.post(`${prefix}/actualizar-estado-trabajo-adicional`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getHistorialTrabajoAdicional(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-historial-trabajo-adicional`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getTrabajoAdicionalPorId(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-trabajo-adicional-por-id`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async deleteArchivoTrabajoAdicional(params) {
        try {
            const data = await zergApi.post(`${prefix}/delete-archivo-trabajo-adicional`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new TrabajoAdicionalService();